<template>
  <div>
    <el-tooltip
      v-if="status === MessageStatus.DELIVERED"
      class="item"
      effect="dark"
      content="Delivered"
      placement="top-start"
    >
      <div>
        <i class="el-icon-check icon-bold"></i>
        <i style="margin-left:-9px" class="el-icon-check icon-bold"></i>
      </div>
    </el-tooltip>
    <el-tooltip
      v-else-if="status === MessageStatus.READ"
      class="item"
      effect="dark"
      content="Read"
      placement="top-start"
    >
      <div>
        <i class="el-icon-check icon-bold has-text-info"></i>
        <i style="margin-left:-9px" class="el-icon-check icon-bold has-text-info"></i>
      </div>
    </el-tooltip>
    <el-tooltip
      v-else-if="status === MessageStatus.SENDING"
      class="item"
      effect="dark"
      content="Sending"
      placement="top-start"
    >
      <i class="el-icon-loading"></i>
    </el-tooltip>
    <el-tooltip
      v-else-if="status === MessageStatus.ERROR || status === MessageStatus.FAILED"
      class="item"
      effect="dark"
      content="Error while sending this message"
      placement="top-start"
    >
      <i class="el-icon-error has-text-danger"></i>
    </el-tooltip>
    <el-tooltip
      v-else
      class="item"
      effect="dark"
      content="Sent"
      placement="top-start"
    >
      <div>
        <i class="el-icon-check icon-bold"></i>
      </div>
    </el-tooltip>
  </div>
</template>

<script>
import { MessageStatus } from "@/store/modules/livechat/types";

export default {
  props: ["status"],
  data() {
    return {
      MessageStatus,
    }
  }
};
</script>
